import {
    Ticket,
    Clock3,
    LoaderCircle,
    CheckCircle2,
} from "lucide-react";

function SupportStats({ stats }) {

    return (

        <div className="support-overview">

            <div className="overview-card">

                <Ticket size={24} />

                <div>

                    <h2>{stats.total || 0}</h2>

                    <p>Total Tickets</p>

                </div>

            </div>

            <div className="overview-card">

                <Clock3 size={24} />

                <div>

                    <h2>{stats.open || 0}</h2>

                    <p>Open</p>

                </div>

            </div>

            <div className="overview-card">

                <LoaderCircle size={24} />

                <div>

                    <h2>{stats.inProgress || 0}</h2>

                    <p>In Progress</p>

                </div>

            </div>

            <div className="overview-card">

                <CheckCircle2 size={24} />

                <div>

                    <h2>{stats.closed || 0}</h2>

                    <p>Closed</p>

                </div>

            </div>

        </div>

    );

}

export default SupportStats;